var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailoredFeature1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 247.25 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#019cae;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#fff;}.cls-5{fill:#c0cdea;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.12,
    y: 31.06,
    width: 60,
    height: 71
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1762",
    "data-name": "Rectangle 1762",
    className: "cls-2",
    x: 3.12,
    y: 1.06,
    width: 71,
    height: 108
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    className: "cls-2",
    x: 88.12,
    y: 1.06,
    width: 71,
    height: 108
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    className: "cls-2",
    d: "M173.12,1.06h71v108h-71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_40",
    "data-name": "Repeat Grid 40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    className: "cls-4",
    x: 8.12,
    y: 31.06,
    width: 60,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763-2",
    "data-name": "Rectangle 1763-2",
    className: "cls-4",
    x: 8.12,
    y: 49.06,
    width: 60,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763-3",
    "data-name": "Rectangle 1763-3",
    className: "cls-4",
    x: 8.12,
    y: 67.06,
    width: 60,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763-4",
    "data-name": "Rectangle 1763-4",
    className: "cls-4",
    x: 8.12,
    y: 85.06,
    width: 60,
    height: 14
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763-5",
    "data-name": "Rectangle 1763-5",
    className: "cls-4",
    x: 94.12,
    y: 31.06,
    width: 60,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763-6",
    "data-name": "Rectangle 1763-6",
    className: "cls-4",
    x: 94.12,
    y: 49.06,
    width: 60,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763-7",
    "data-name": "Rectangle 1763-7",
    className: "cls-5",
    x: 94.12,
    y: 67.06,
    width: 60,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763-8",
    "data-name": "Rectangle 1763-8",
    className: "cls-5",
    x: 94.12,
    y: 85.06,
    width: 60,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763-9",
    "data-name": "Rectangle 1763-9",
    className: "cls-4",
    x: 179.12,
    y: 31.06,
    width: 60,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763-10",
    "data-name": "Rectangle 1763-10",
    className: "cls-5",
    x: 179.12,
    y: 49.06,
    width: 60,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763-11",
    "data-name": "Rectangle 1763-11",
    className: "cls-5",
    x: 179.12,
    y: 67.06,
    width: 60,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763-12",
    "data-name": "Rectangle 1763-12",
    className: "cls-5",
    x: 179.12,
    y: 85.06,
    width: 60,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1797",
    "data-name": "Rectangle 1797",
    className: "cls-4",
    d: "M18.62,16.06h39a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5h-39a1.5,1.5,0,0,1-1.5-1.5h0A1.5,1.5,0,0,1,18.62,16.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1798",
    "data-name": "Rectangle 1798",
    className: "cls-4",
    d: "M104.62,16.06h39a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5h-39a1.5,1.5,0,0,1-1.5-1.5h0A1.5,1.5,0,0,1,104.62,16.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1799",
    "data-name": "Rectangle 1799",
    className: "cls-4",
    d: "M189.62,16.06h39a1.5,1.5,0,0,1,1.5,1.5h0a1.5,1.5,0,0,1-1.5,1.5h-39a1.5,1.5,0,0,1-1.5-1.5h0A1.5,1.5,0,0,1,189.62,16.06Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailoredFeature1);
export default __webpack_public_path__ + "static/media/tailoredFeature1.d66996a7a442ad1e031dccd47abc634d.svg";
export { ForwardRef as ReactComponent };